var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-end justify-content-center"},[_c('img',{staticClass:"geo-img",attrs:{"src":"Geo_Impact.svg","alt":"Click to watch the intro video"},on:{"click":_vm.toggleVideoFrame}})])
}
var staticRenderFns = []

export { render, staticRenderFns }